import { Typography } from '@mui/material';
import React from 'react';
import { useStyling } from '../../../common/Theme';
import I18n from '../../../common/i18n/I18n';

export default () => {
    const { theme } = useStyling();

    return (
        <Typography
            fontWeight={theme.typography.fontWeightBold}
            fontSize={theme.typography.body2.fontSize}
            sx={{
                textTransform: 'uppercase'
            }}
        >
            <I18n token="common.status" />
        </Typography>
    );
};
